import React, { useState } from 'react'
import styled from 'styled-components'
import { useIntl } from 'gatsby-plugin-intl'
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined'
import PrivateRoomsManager from 'src/features/exchangeRooms/PrivateRoomsManager'

const ManagePrivateRoomsButton = ({ exchangeType, className }) => {
  const intl = useIntl()
  const [open, setOpen] = useState(false)

  return (
    <>
      <TriggerButton
        type='button'
        className={className}
        onClick={() => setOpen(true)}
        title={intl.formatMessage({
          id: 'forms.privateRoomEditMembersBtnTooltip'
        })}
      >
        <ButtonIcon />
        <span>
          {intl.formatMessage({ id: 'forms.privateRoomEditMembersBtnText' })}
        </span>
      </TriggerButton>

      <PrivateRoomsManager
        open={open}
        onClose={() => setOpen(false)}
        exchangeType={exchangeType}
      />
    </>
  )
}

const TriggerButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  border: 1px solid ${({ theme }) => theme.colors.ghost.hex()};
  border-radius: 2px;
  background: ${({ theme }) => theme.colors.white.hex()};
  color: ${({ theme }) => theme.colors.ebonyClay.alpha(0.8).hex()};
  cursor: pointer;
  font-size: 0.8rem;
  font-weight: 600;
  min-height: 40px;
  padding: 0.45rem 0.8rem;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s;

  &:hover {
    background: ${({ theme }) => theme.colors.ebonyClay.alpha(0.04).hex()};
    color: ${({ theme }) => theme.colors.easternBlue.hex()};
    border-color: ${({ theme }) => theme.colors.easternBlue.hex()};
  }
`

const ButtonIcon = styled(SettingsOutlinedIcon)`
  font-size: 1rem !important;
`

export default ManagePrivateRoomsButton
